import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./About.css";

const About = () => {
  return (
    <React.Fragment>
      <Row>
        <Col className="about">
          <img
            alt="profile"
            src="https://images.unsplash.com/photo-1612301973929-ce3cc5ec04b4?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80"
          ></img>
          <div className="desc">
            <h1>This project is made with -</h1>
            <ul className="features">
              <li>
                <i className="fad fa-pencil"></i>
                <a href="/" target="_blank">
                  <img src="/django.svg" alt="logo" />
                </a>
              </li>
              <li>
                <i className="fad fa-pencil"></i>
                <a href="/" target="_blank">
                  <img
                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K"
                    alt="logo"
                  />
                </a>
              </li>
            </ul>
          </div>
        </Col>
      </Row>
      <footer>
        <ul>github</ul>
        <ul>linkedIn</ul>
      </footer>
    </React.Fragment>
  );
};

export default About;
